interface Props {
  clue: string;
}

export default function ClueBlock({ clue }: Props) {
  return (
    <div className="clue-block">
      <div className="clue-inner">
        <span className="clue-icon">Detective's Note</span>
        <p
          className="clue-text"
          dangerouslySetInnerHTML={{ __html: clue }}
        />
      </div>
    </div>
  );
}
